import { render, staticRenderFns } from "./localeSwitcher.vue?vue&type=template&id=44af04b3&"
import script from "./localeSwitcher.vue?vue&type=script&lang=js&"
export * from "./localeSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./localeSwitcher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports